import {BaseApi} from './base-api';
import Vue from 'vue';

export class RecurringMiscApi extends BaseApi {
  static apiUri = 'recurring-misc';

  /** @return {Promise<EntityHttpResponse<PageResponse<RecurringMiscDto[]>>>} */
  static getAll (params = null) {
    return Vue.http.get(this.apiUri, params)
  }

  /**
   * @return {Promise<EntityHttpResponse<RecurringMiscDto>>}
   * @param {RecurringMiscRequest} miscCreateRequest
   * */
  static create (miscCreateRequest) {
    return Vue.http.post(this.apiUri, miscCreateRequest)
  }

  /**
   * @return {Promise<EntityHttpResponse<RecurringMiscDto>>}
   * @param {Number} miscId
   * @param {RecurringMiscRequest} miscUpdateRequest
   * */
  static update (miscId, miscUpdateRequest) {
    return Vue.http.put(this.apiUri + '/' + miscId, miscUpdateRequest)
  }

  /**
   * @return {Promise<EntityHttpResponse<void>>}
   * @param {Number} miscId
   * */
  static delete (miscId) {
    return Vue.http.delete(this.apiUri + '/' + miscId)
  }
}
